import _implicitStylesheets from "./skillSidebar.css";
import _implicitScopedStylesheets from "./skillSidebar.scoped.css?scoped=true";
import _listingHarnessIcon from "listing/harnessIcon";
import _listingInstallMethodDropdown from "listing/installMethodDropdown";
import _wdsButton from "wds/button";
import _listingGuidedInstallModal from "listing/guidedInstallModal";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span class="row-label${0}"${2}>${"t1"}</span>`;
const $fragment2 = parseFragment`<div class="install-note${0}"${2}>${"t1"}</div>`;
const stc0 = {
  classMap: {
    "install-box": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "install-heading": true
  },
  attrs: {
    "type-style": "display-7"
  },
  key: 1
};
const stc2 = {
  "install-heading-icon": true
};
const stc3 = {
  classMap: {
    "install-method": true
  },
  key: 3
};
const stc4 = {
  "install-method-select": true
};
const stc5 = {
  classMap: {
    "install-actions": true
  },
  key: 7
};
const stc6 = {
  "primary-install-action": true
};
const stc7 = {
  "data-testid": "download-zip-button"
};
const stc8 = {
  "data-testid": "get-install-prompt-button"
};
const stc9 = {
  "data-testid": "cli-script-button"
};
const stc10 = {
  "view-source-action": true
};
const stc11 = {
  "data-testid": "view-source-button"
};
const stc12 = {
  classMap: {
    "more-options": true
  },
  key: 12
};
const stc13 = {
  "more-options-toggle": true
};
const stc14 = {
  "data-testid": "more-options-toggle"
};
const stc15 = {
  "install-actions": true
};
const stc16 = {
  "data-testid": "secondary-get-install-prompt-button"
};
const stc17 = {
  "data-testid": "secondary-cli-script-button"
};
const stc18 = {
  "data-testid": "secondary-add-to-claude-desktop-button"
};
const stc19 = {
  "data-id": "install-prompt-modal"
};
const stc20 = {
  "data-id": "cli-script-modal"
};
const stc21 = {
  "data-id": "claude-desktop-modal"
};
const stc22 = {
  "data-id": "install-in-claude-modal"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, d: api_dynamic_text, t: api_text, h: api_element, sp: api_static_part, st: api_static_fragment, b: api_bind, gid: api_scoped_id} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7, _m8, _m9, _m10, _m11, _m12, _m13, _m14, _m15} = $ctx;
  return [api_element("div", stc0, [api_element("h3", stc1, [$cmp.singleHarnessId ? api_custom_element("listing-harness-icon", _listingHarnessIcon, {
    classMap: stc2,
    props: {
      "installMethodId": $cmp.singleHarnessId
    },
    key: 2
  }) : null, api_text(api_dynamic_text($cmp.headingLabel))]), !$cmp.isExternalInstall ? $cmp.hasMultipleHarnesses ? api_element("div", stc3, [api_static_fragment($fragment1, 5, [api_static_part(1, null, api_dynamic_text($cmp.installForLabel))]), api_custom_element("listing-install-method-dropdown", _listingInstallMethodDropdown, {
    classMap: stc4,
    props: {
      "options": $cmp.installMethodOptions,
      "selectedId": $cmp.effectiveInstallMethodId,
      "ariaLabel": $cmp.installForLabel
    },
    key: 6,
    on: {
      "change": _m0 || ($ctx._m0 = api_bind($cmp.handleInstallMethodChange))
    }
  })]) : null : null, !$cmp.isExternalInstall ? api_element("div", stc5, [$cmp.isPrimaryZip ? api_custom_element("wds-button", _wdsButton, {
    classMap: stc6,
    attrs: stc7,
    props: {
      "variant": "primary",
      "width": "fill",
      "label": $cmp.downloadZipLabel,
      "icon": "download",
      "name": "download-zip",
      "href": $cmp.zipUrl
    },
    key: 8,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.handleDownloadZip)),
      "analytics": _m2 || ($ctx._m2 = api_bind($cmp.handleDownloadZipAnalytics))
    }
  }) : null, $cmp.isPrimaryPrompt ? api_custom_element("wds-button", _wdsButton, {
    classMap: stc6,
    attrs: stc8,
    props: {
      "variant": "primary",
      "width": "fill",
      "label": $cmp.getInstallPromptLabel,
      "icon": "copy",
      "name": "get-install-prompt"
    },
    key: 9,
    on: {
      "click": _m3 || ($ctx._m3 = api_bind($cmp.handleGetInstallPrompt)),
      "analytics": _m4 || ($ctx._m4 = api_bind($cmp.handleGetInstallPromptAnalytics))
    }
  }) : null, $cmp.isPrimaryCli ? api_custom_element("wds-button", _wdsButton, {
    classMap: stc6,
    attrs: stc9,
    props: {
      "variant": "primary",
      "width": "fill",
      "label": $cmp.cliScriptLabel,
      "icon": "apex",
      "name": "cli-script"
    },
    key: 10,
    on: {
      "click": _m5 || ($ctx._m5 = api_bind($cmp.handleCliScript)),
      "analytics": _m6 || ($ctx._m6 = api_bind($cmp.handleCliScriptAnalytics))
    }
  }) : null, $cmp.hasSourceUrl ? api_custom_element("wds-button", _wdsButton, {
    classMap: stc10,
    attrs: stc11,
    props: {
      "variant": "tertiary",
      "label": $cmp.viewOnGitHubLabel,
      "icon": "new_window",
      "name": "view-source",
      "href": $cmp.sourceUrl,
      "target": "_blank"
    },
    key: 11,
    on: {
      "analytics": _m7 || ($ctx._m7 = api_bind($cmp.handleViewSourceAnalytics))
    }
  }) : null]) : null, !$cmp.isExternalInstall ? $cmp.hasSecondaryOptions ? api_element("div", stc12, [api_custom_element("wds-button", _wdsButton, {
    classMap: stc13,
    attrs: stc14,
    props: {
      "variant": "tertiary",
      "label": $cmp.moreOptionsLabel,
      "icon": $cmp.moreOptionsIcon,
      "iconPlacement": "end",
      "name": "more-options",
      "ariaExpanded": $cmp.moreOptionsAriaExpanded,
      "ariaControls": api_scoped_id("more-options-panel")
    },
    key: 13,
    on: {
      "click": _m8 || ($ctx._m8 = api_bind($cmp.handleToggleMoreOptions)),
      "analytics": _m9 || ($ctx._m9 = api_bind($cmp.handleMoreOptionsAnalytics))
    }
  })]) : null : null, !$cmp.isExternalInstall ? $cmp.hasSecondaryOptions ? api_element("div", {
    classMap: stc15,
    attrs: {
      "hidden": $cmp.moreOptionsCollapsed ? "" : null,
      "id": api_scoped_id("more-options-panel"),
      "data-testid": "more-options-panel"
    },
    key: 14
  }, [$cmp.hasSecondaryPrompt ? api_custom_element("wds-button", _wdsButton, {
    attrs: stc16,
    props: {
      "variant": "secondary",
      "width": "fill",
      "label": $cmp.getInstallPromptLabel,
      "icon": "copy",
      "name": "get-install-prompt"
    },
    key: 15,
    on: {
      "click": _m10 || ($ctx._m10 = api_bind($cmp.handleGetInstallPrompt)),
      "analytics": _m11 || ($ctx._m11 = api_bind($cmp.handleGetInstallPromptAnalytics))
    }
  }) : null, $cmp.hasSecondaryCli ? api_custom_element("wds-button", _wdsButton, {
    attrs: stc17,
    props: {
      "variant": "secondary",
      "width": "fill",
      "label": $cmp.cliScriptLabel,
      "icon": "apex",
      "name": "cli-script"
    },
    key: 16,
    on: {
      "click": _m12 || ($ctx._m12 = api_bind($cmp.handleCliScript)),
      "analytics": _m13 || ($ctx._m13 = api_bind($cmp.handleCliScriptAnalytics))
    }
  }) : null, $cmp.hasSecondaryDesktop ? api_custom_element("wds-button", _wdsButton, {
    attrs: stc18,
    props: {
      "variant": "secondary",
      "width": "fill",
      "label": $cmp.addToClaudeDesktopLabel,
      "icon": "new_window",
      "name": "add-to-claude-desktop"
    },
    key: 17,
    on: {
      "click": _m14 || ($ctx._m14 = api_bind($cmp.handleAddToClaudeDesktop)),
      "analytics": _m15 || ($ctx._m15 = api_bind($cmp.handleAddToClaudeDesktopAnalytics))
    }
  }) : null]) : null : null, !$cmp.isExternalInstall ? $cmp.isAutoInstalled ? api_static_fragment($fragment2, 19, [api_static_part(1, null, api_dynamic_text($cmp.labels.installAutoIncluded))]) : null : null]), !$cmp.isExternalInstall ? api_custom_element("listing-guided-install-modal", _listingGuidedInstallModal, {
    attrs: stc19,
    props: {
      "listing": $cmp.listing,
      "installMethodId": $cmp.effectiveInstallMethodId
    },
    key: 20
  }) : null, !$cmp.isExternalInstall ? api_custom_element("listing-guided-install-modal", _listingGuidedInstallModal, {
    attrs: stc20,
    props: {
      "listing": $cmp.listing,
      "installMethodId": $cmp.effectiveInstallMethodId,
      "mode": "cli"
    },
    key: 21
  }) : null, !$cmp.isExternalInstall ? api_custom_element("listing-guided-install-modal", _listingGuidedInstallModal, {
    attrs: stc21,
    props: {
      "listing": $cmp.listing,
      "installMethodId": $cmp.effectiveInstallMethodId,
      "zipUrl": $cmp.zipUrl,
      "mode": "desktop"
    },
    key: 22
  }) : null, !$cmp.isExternalInstall ? api_custom_element("listing-guided-install-modal", _listingGuidedInstallModal, {
    attrs: stc22,
    props: {
      "listing": $cmp.listing,
      "installMethodId": $cmp.effectiveInstallMethodId,
      "mode": "zip"
    },
    key: 23
  }) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-4nlpcgusrro";
tmpl.legacyStylesheetToken = "undefined-_skillSidebar";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
